import {SET_SELECTED_FREEZE} from 'constants/action-types.js';
import {SET_FREEZE_DRAGGING} from 'constants/action-types.js';
import {SET_FREEZE_COLUMN_SAMPLES} from 'constants/action-types.js';
import {SET_OFFLINE_ENGINE} from 'constants/action-types.js';
import {SET_CURRENT_EXPORT_INFO} from 'constants/action-types.js';
import {SET_LOOPS_TO_FREEZE} from 'constants/action-types.js';

let initialState = {
    selectedFreeze: undefined,
    offlineEngine: undefined,
    freezeDragging: undefined,
    freezeColumnSamples: {},
    currentExportInfo: undefined,
    loops: 1
};
    
const freezeReducer = (state = initialState, action) => {
    let newState;
    switch (action.type) {
    case SET_CURRENT_EXPORT_INFO:
        return {
            ... state,
            currentExportInfo: action.payload
        };
    case SET_FREEZE_COLUMN_SAMPLES:
        let trackFreezes = {... state.freezeColumnSamples[action.payload.trackId]};
        trackFreezes[action.payload.column] = action.payload.samples;
        let freezeColumnSamples = {... state.freezeColumnSamples};
        freezeColumnSamples[action.payload.trackId] = trackFreezes;
        return {
            ... state,
            freezeColumnSamples
        };
    case SET_LOOPS_TO_FREEZE:
        return {
            ...state,
            loops: action.payload
        };
    case SET_SELECTED_FREEZE:
        return {
            ... state,
            selectedFreeze: action.payload
        };
    case SET_FREEZE_DRAGGING:
        return {
            ... state,
            freezeDragging: action.payload
        };
   case SET_OFFLINE_ENGINE:
        return {
            ... state,
            offlineEngine: action.payload
        };
    default:
        return state;
    }
};

export default freezeReducer;
